module.exports = __webpack_public_path__ + "static/image/company/pc/image_better@3x.jpg?7ad21231";